import { render, staticRenderFns } from "./BulderDialog.vue?vue&type=template&id=39b1457c"
import script from "./BulderDialog.vue?vue&type=script&lang=js"
export * from "./BulderDialog.vue?vue&type=script&lang=js"
import style0 from "./BulderDialog.vue?vue&type=style&index=0&id=39b1457c&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39b1457c')) {
      api.createRecord('39b1457c', component.options)
    } else {
      api.reload('39b1457c', component.options)
    }
    module.hot.accept("./BulderDialog.vue?vue&type=template&id=39b1457c", function () {
      api.rerender('39b1457c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/dialog/BulderDialog.vue"
export default component.exports